<div id="conversation-container" *ngIf="userReceiver" #scrolleur>
	<div
		*ngFor="let message of messages; trackBy: trackMessages; let last = last"
	>
		<div
			class="row mt-4"
			*ngIf="!precedentDate(message, messages) && !isToday(message.createdAt)"
		>
			<div class="col text-center fw-bold theme-main-color">
				{{ message.createdAt | date: 'dd/MM/yyyy' }}
			</div>
		</div>

		<div
			class="row mt-4"
			*ngIf="!precedentDate(message, messages) && isToday(message.createdAt)"
		>
			<div class="col text-center fw-bold theme-main-color">Aujourd'hui</div>
		</div>
		<div class="row p-2">
			<div
				class="d-flex"
				[ngClass]="
					isFromCurrentUser(message)
						? 'justify-content-start'
						: 'justify-content-end'
				"
			>
				<div style="width: 50%">
					<p
						class="message msg-content p-1 rounded"
						[ngClass]="
							isFromCurrentUser(message)
								? 'theme-blue-background-color text-white'
								: 'justify-content-end theme-green-background-color'
						"
					>
						{{ message.messageContent }}
					</p>
					<span
						class="msg-content"
						[ngClass]="isFromCurrentUser(message) && 'justify-content-end'"
						>{{ message.createdAt | date: 'dd/MM/yyyy | HH:mm' }}</span
					>
				</div>
			</div>
		</div>

		<!-- SI C'EST LE DERNIER ÉLÉMENT ON SCROLL JUSQU'À LUI -->
		{{ last ? scrollToBottom() : '' }}
	</div>
</div>
